import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white px-6 py-4" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 font-semibold" }, "Ответ 1С:", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Заказ (ID): " + _toDisplayString(_ctx.item.id), 1),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.state.is_loading,
        onClick: _ctx.resend
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Переотправить по ID ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _createElementVNode("p", _hoisted_4, "Дата создания: " + _toDisplayString(_ctx.formatDate(_ctx.item.createdAt)), 1),
    _createElementVNode("p", null, "Номер: " + _toDisplayString(_ctx.item.invoiceNumber), 1),
    _createElementVNode("p", null, "Компания: " + _toDisplayString(_ctx.item.companyName), 1),
    _createElementVNode("p", null, "Курьер: " + _toDisplayString(_ctx.item.courierName), 1),
    _createElementVNode("p", null, "Город: " + _toDisplayString(_ctx.item.address), 1),
    _hoisted_5,
    (JSON.parse(_ctx.item.response1c))
      ? (_openBlock(), _createElementBlock("pre", _hoisted_6, "            " + _toDisplayString(JSON.parse(_ctx.item.response1c)) + "\n        ", 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString((_ctx.item.response1c && decodeURI(_ctx.item.response1c)) || _ctx.item.response1c || 'Нет данных'), 1))
  ]))
}